import { useEffect } from 'react';

import { LOAN_REQUEST_OFFER_SOURCES } from 'cpool-constants';
import { useTranslation } from 'react-i18next';

import { OfferExtraInfoDialog } from './OfferExtraInfoDialog';
import { InfoSidebarModal } from '../../../InfoSidebarModal';
import Spinner from '~/components/icons/Spinner';
import { useOfferById } from '~/features/leadDetails/components/Overview/OfferManagement/hooks/useOfferById';

type Props = {
    leadId: string;
    offerId: string;
    onClose: () => void;
};

export const RouteOfferExtraInfoDialog: React.FC<Props> = ({ leadId, offerId, onClose }) => {
    const { t } = useTranslation();
    const { data, isError, isLoading, isSuccess } = useOfferById({ aggregateId: leadId, offerId });
    const isSupportedOffer =
        data?.source === LOAN_REQUEST_OFFER_SOURCES.EUROPACE ||
        data?.source === LOAN_REQUEST_OFFER_SOURCES.EUROPACE_SYNC;

    useEffect(() => {
        if (isSuccess && !isSupportedOffer) onClose();
    }, [isSuccess, isSupportedOffer, onClose]);

    if (isLoading) {
        return (
            <InfoSidebarModal
                title={t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.TITLE')}
                open
                onClose={onClose}
                testId="offerExtraInfoLoadingDialog"
            >
                <Spinner />
            </InfoSidebarModal>
        );
    }

    if (isError) {
        return (
            <InfoSidebarModal
                title={t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.TITLE')}
                open
                onClose={onClose}
                testId="offerExtraInfoErrorDialog"
            >
                <p>{t('errorPage.error')}</p>
            </InfoSidebarModal>
        );
    }

    if (!data || !isSupportedOffer) return null;

    return (
        <OfferExtraInfoDialog
            {...data}
            isOpen
            setIsOpen={(open) => {
                if (!open) onClose();
            }}
        />
    );
};
